import { render, staticRenderFns } from "./connectGroupDrawer.vue?vue&type=template&id=20f4222b&scoped=true"
import script from "./connectGroupDrawer.vue?vue&type=script&lang=js"
export * from "./connectGroupDrawer.vue?vue&type=script&lang=js"
import style0 from "./connectGroupDrawer.vue?vue&type=style&index=0&id=20f4222b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f4222b",
  null
  
)

export default component.exports